export default {
  tableColors: {
    WAITING: 'lemon',
    APPROVED: 'green',
    AUTO_APPROVED: 'green',
    STARTED: 'green',
    CLIENT_DO_NOT_CAME: 'white',
    FINISHED: 'red',
  },
  sameReserveColor: [
    { backgroundColor: '#00A3FF', color: '#000000' },
    { backgroundColor: '#00a3ff80', color: '#000000' },
    { backgroundColor: '#0000FF', color: '#FFFFFF' },
    { backgroundColor: '#00FFFF', color: '#000000' },
    { backgroundColor: '#89CFF0', color: '#000000' },
    { backgroundColor: '#7DF9FF', color: '#000000' },
    { backgroundColor: '#ADD8E6', color: '#000000' },
    { backgroundColor: '#A7C7E7', color: '#000000' },
    { backgroundColor: '#96DED1', color: '#000000' },
    { backgroundColor: '#0437F2', color: '#FFFFFF' },
    { backgroundColor: '#9FE2BF', color: '#000000' },
    { backgroundColor: '#87CEEB', color: '#000000' },
    { backgroundColor: '#9FE2BF', color: '#000000' },
    { backgroundColor: '#4682B4', color: '#FFFFFF' },
    { backgroundColor: '#191970', color: '#FFFFFF' },
    { backgroundColor: '#008080', color: '#FFFFFF' },
    { backgroundColor: '#1F51FF', color: '#FFFFFF' },
    { backgroundColor: '#0818A8', color: '#FFFFFF' },
    { backgroundColor: '#7393B3', color: '#000000' },
    { backgroundColor: '#F0FFFF', color: '#000000' },
  ],
  badgeColors: {
    WAITING: '#FFB800',
    APPROVED: '#338A5F',
    AUTO_APPROVED: '#338A5F',
    STARTED: '#338A5F',
    CLIENT_DO_NOT_CAME: '#dc3545',
    FINISHED: '#E53935',
  },
  tableTimeStatus: {
    DISABLE: 'disabled',
    READY: '',
  },
};
